import { h, render, Component } from 'preact';
import PropTypes from 'prop-types';
import { IntlProvider } from 'react-intl';

import { DEFAULT_LOCALE } from 'utils/constants';

export class LanguageProvider extends Component {
  render(props, state) {
    return (
      <IntlProvider locale={DEFAULT_LOCALE} key={DEFAULT_LOCALE} messages={this.props.messages[DEFAULT_LOCALE]}>
        {props.children}
      </IntlProvider>
    )
  }
}

export default LanguageProvider;